import React from 'react'
import { Button } from 'reactstrap';
import { FormIndicationsLab } from './FormIndicationsLab';
import { Dialog } from 'primereact/dialog';

export const ModalIndicationsLab = (props) => {

    const {
        method4, modalTitle4, loading2, modal4,
        saveCreate2,handleInputChange2,saveUpdate2,validaciones2,
        id_exam_indication2, indication2, closeDialog

    }= props;

    const footer = (
        <>
        <hr />
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                disabled={loading2}
                onClick={method4 === "create" ? saveCreate2 : saveUpdate2}
                className={loading2 ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading2
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                {
                                    method4 === "create"
                                        ? "Guardando..."
                                        : "Actualizando..."
                                }
                            </>
                        )
                        : (
                            method4 === "create"
                                ? "Guardar"
                                : "Actualizar"
                        )
                }
            </Button>
        </>
    );

    return (
        <Dialog 
            header={modalTitle4}
            visible={modal4} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            maskClassName="medium-dialog-mask"
            footer={footer}
        >
        {
            method4 === "create"
                ? <FormIndicationsLab
                    button="Guardar"
                    {...{ loading2, handleInputChange2,validaciones2,methodAction: saveCreate2}}
                />
                : (method4 === "update")

                    ?
                    <FormIndicationsLab
                        button="Actualizar"
                        {...{
                            loading2, handleInputChange2,id_exam_indication2, indication2,validaciones2,  methodAction: saveUpdate2,
                        }}
                    />
                    :
                    null
                    
                    
        }
    </Dialog>
       
    )
}
